import { create } from 'zustand';

interface TrackedJob {
  jobId: string;
  startedAt: number;
}

interface State {
  jobs: TrackedJob[];
  track: (jobId: string) => void;
  untrack: (jobId: string) => void;
  clear: () => void;
}

export const useTranslateJobsStore = create<State>((set) => ({
  jobs: [],
  track: (jobId) =>
    set((s) => ({
      jobs: [...s.jobs.filter((j) => j.jobId !== jobId), { jobId, startedAt: Date.now() }],
    })),
  untrack: (jobId) => set((s) => ({ jobs: s.jobs.filter((j) => j.jobId !== jobId) })),
  clear: () => set({ jobs: [] }),
}));
